import { z } from 'zod'

const HealthStatusSchema = z.enum(['healthy', 'warning', 'error', 'unknown'])

export const KuroBoardProjectSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.enum(['planned', 'in_progress', 'blocked', 'done', 'archived']),
  priority: z.enum(['low', 'medium', 'high', 'urgent']),
  owner: z.string().optional(),
  updatedAt: z.string(),
  taskCounts: z.object({
    todo: z.number(),
    in_progress: z.number(),
    blocked: z.number(),
    done: z.number(),
  }),
})

export const KuroBoardTaskSummarySchema = z.object({
  id: z.string(),
  projectId: z.string(),
  title: z.string(),
  status: z.enum(['todo', 'in_progress', 'blocked', 'done']),
  assignee: z.string().optional(),
  priority: z.enum(['low', 'medium', 'high', 'urgent']),
  updatedAt: z.string(),
})

export const KuroBoardOverviewSchema = z.object({
  summary: z.object({
    projectCount: z.number(),
    activeProjectCount: z.number(),
    blockedTaskCount: z.number(),
    dueSoonTaskCount: z.number(),
    unreadNotificationCount: z.number(),
  }),
  agentStatus: z.array(
    z.object({
      agentId: z.string(),
      name: z.string(),
      status: HealthStatusSchema,
      lastSeenAt: z.string(),
      currentTask: z.string().optional(),
    })
  ),
  recentProjects: z.array(KuroBoardProjectSummarySchema),
  recentTasks: z.array(KuroBoardTaskSummarySchema),
})

export const KuroBoardProjectsSchema = z.object({
  projects: z.array(KuroBoardProjectSummarySchema),
})

export const KuroBoardNotificationsSchema = z.object({
  notifications: z.array(
    z.object({
      id: z.string(),
      level: z.enum(['info', 'warning', 'error']),
      title: z.string(),
      body: z.string(),
      createdAt: z.string(),
      read: z.boolean(),
      source: z.string(),
      relatedProjectId: z.string().optional(),
    })
  ),
})

export const KuroBoardProjectDetailSchema = KuroBoardProjectSummarySchema.extend({
  description: z.string().optional(),
  tasks: z.array(KuroBoardTaskSummarySchema),
})
